module.exports = __webpack_public_path__ + "images/marker-icon.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/marker-icon.png
// module id = 178
// module chunks = 0